import { useQuery } from "react-query";

import { loadSavedFilters } from "api/userDefaults";

import { SavedFilterModel } from "models";

/**
 * Loads all saved filters accessible to the current user across all scopes
 * (System, Org, Team, Personal). No projectId is sent — the backend uses
 * the JWT claims to scope the response appropriately.
 */
export function useGetAllAvailableSavedFilters(enabled = true) {
  const { isLoading, isError, error, data, refetch } = useQuery<SavedFilterModel[]>(
    ["allAvailableSavedFilters"],
    async () => {
      const result = await loadSavedFilters();
      return (result?.savedFilters as SavedFilterModel[]) ?? [];
    },
    {
      enabled
    }
  );

  return {
    savedFilters: data ?? [],
    isLoading,
    isError,
    error,
    refetch
  };
}
